import React, { Component } from 'react';
import './Home.css';
// import Carousel from '../components/Carousel';
import BCarousel from '../components/MDBCarousel';
import Categories from '../components/Categories';
import Product from '../components/Product'
import {ProductConsumer} from '../context';


class Home extends Component {

    render() {
        return (
            <div>
                <BCarousel/>
                {/* <Carousel/> */}
                <Categories />
                <div className="container">
                    <h1 className="field my-5">Now Trending</h1>
                </div>
                <div className="container">
                    <div className="row justify-content-between my-5">
                        <ProductConsumer>
                            {value =>{
                                return value.products.filter(k=>k.trending===true).map(product =>{
                                   return <Product key={product.id} products={product}/>;
                                })
                            }}
                        </ProductConsumer>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;
